import { Box, ButtonBS, colors, Heading, LinkBox, Text, VStack } from "@biblioteksentralen/react";
import { ResolvedAdventCalendarSummary } from "@libry-content/common";
import { useState } from "react";
import { logClick } from "../../utils/analytics/Plausible";
import { Breakpoint } from "../../utils/chakraUtils";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { Edit } from "../editInSanity/EditInSanity";
import { LocalizedNextLink } from "../LocalizedNextLink";
import { getContainerQuery } from "../site/banners/promotedItems/utils";
import { ChristmasPresentColor } from "./ChristmasPresent/ChristmasPresent";
import { Presents } from "./ChristmasPresent/ChristmasPresents";

type Props = {
  title: string;
  text: string;
  href?: string;
  presentColors?: ChristmasPresentColor[];
  adventCalendar: ResolvedAdventCalendarSummary;
  hidePresentsBelow?: Breakpoint;
};

const AdventCalendarBanner = (props: Props) => {
  const { adventCalendar, href, text, title } = props;

  const { t } = useTranslation();

  // FIXME: Linkbox not working
  const Wrapper = href ? LinkBox : Box;

  // We can't use _groupHover because this can't control the animationPlayState prop
  const [hovered, setHovered] = useState(false);

  return (
    <Wrapper
      width="100%"
      display="grid"
      onClick={href ? () => logClick("AdventCalendarBanner") : undefined}
      textDecoration="none"
      position="relative"
      className="group"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      containerType="inline-size"
      padding="1.5rem .75rem"
      borderRadius={{ base: "none", md: "lg" }}
      background={colors.statusGreenLight}
    >
      <VStack gap="1.5rem" css={getContainerQuery({ base: { margin: "0 0 2rem" }, md: { margin: 0 } })}>
        <Heading fontSize="3xl">{title}</Heading>
        <Text css={getContainerQuery({ base: { fontSize: "sm" }, sm: { fontSize: "md" } })} marginTop="0!important">
          {text}
        </Text>
        {href && (
          <ButtonBS
            href={href}
            as={LocalizedNextLink}
            variant="secondary"
            width="100%"
            maxWidth="15rem"
            marginTop="0!important"
          >
            {t("Se julekalenderen")}
          </ButtonBS>
        )}
        <Edit doc={adventCalendar} label={t("Oppdater julekalender")} />
      </VStack>
      <Presents hovered={hovered} presentColors={props.presentColors} hidePresentsBelow={props.hidePresentsBelow} />
    </Wrapper>
  );
};

// Lagde wrapper pga urelatert jest-test som feilet pga at AdventCalendarBanner bruker noen hooks som jest ikke takler
const AdventCalendarBannerWrapper = (props: Props) => <AdventCalendarBanner {...props} />;

export default AdventCalendarBannerWrapper;
